import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveIcon from '@mui/icons-material/Remove';
import { TableCell, Theme, styled, Typography } from '@mui/material';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.v4.border}`,
  verticalAlign: 'middle',
  padding: '5px',
}));

/** Column header, matching every other table header in the app. */
export const BoldLabel = styled(Typography)(({ theme }) => ({
  fontSize: '11px',
  fontWeight: 600,
  color: theme.palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  padding: 0,
}));

/** The package type's name — a fixed label, so it reads as a chip, not a field. */
export const NameLabel = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  padding: '6px 8px',
  minWidth: 100,
  fontSize: '12px',
  fontWeight: 500,
  borderRadius: 4,
  backgroundColor: theme.palette.v4.tableEven,
  border: `1px solid ${theme.palette.v4.border}`,
}));

/** The qty stepper's two icon buttons — one recipe so they can't drift apart. */
const stepperIconSx = (theme: Theme) => ({
  padding: '5px',
  borderRadius: 4,
  backgroundColor: theme.palette.v4.accent,
  color: theme.palette.common.white,
  fontSize: 24,
});

export const RemoveButton = styled(RemoveIcon)(({ theme }) => stepperIconSx(theme));

export const AddButton = styled(AddIcon)(({ theme }) => stepperIconSx(theme));

/** The same delete affordance every other row in the app uses. */
export const ClearButton = styled(DeleteIcon)({
  fontSize: 18,
});

/**
 * Column widths. The numeric columns used to be `fullWidth` and split the row
 * evenly, which pushed Packaging Type under the delete button. Sizing them to
 * the digits they actually hold leaves the type picker and the bin room of
 * their own.
 */
export const quantityColumnSx = { width: 132 };

export const weightColumnSx = { width: 88 };

export const dimensionColumnSx = { width: 92 };

export const actionColumnSx = { width: 44, paddingRight: 0 };
